<template>

    <div class="website::admin-websitePages-createEdit-ModuleEditor mt-5">

        <div class="bg-white overflow-hidden shadow rounded-lg divide-y divide-gray-200 my-10">

            <Gallery
                v-if="!websitePage || !websitePage.module_id"
                :modulesData="modulesData"
                :websitePage="websitePage"
                @moduleChoosed="setModule($event)"
            />

            <Options
                v-else
                :websitePage="websitePage"
                :modulesData="modulesData"
                @clearModule="setModule(null)"
            />

        </div>

    </div>

</template>

<script>

import Gallery from './moduleEditor/Gallery';
import Options from './moduleEditor/Options';

export default {

    components: {
        Gallery,
        Options,
    },

    props: {
        websitePage: Object,
        modulesData: Object,
    },

    methods: {

        setModule(moduleId)
        {
            // Set
            this.$set(this.websitePage, 'module_id', moduleId);
            this.$set(this.websitePage, 'module_options', null);

            // @ugly Otherwise gallery wont show up when moduleId == null
            this.$forceUpdate();
        },
    }

}

</script>

<style lang="scss" scoped>

.website\:\:admin-websitePages-createEdit-moduleEditor-Content {
    background: 0;
}

</style>
